/* eslint-disable @typescript-eslint/no-var-requires */

import { ComponentPropsWithoutRef, FC, SVGProps } from 'react';
import { config } from '@/config';

type IconComponent = FC<SVGProps<SVGSVGElement>>;
type IconModule = { [key: string]: IconComponent };

const getIcon = (path: string): IconComponent => {
    const pathParts = path.split('/');
    const name = pathParts.pop() ?? '';

    let iconModule: IconModule;

    try {
        iconModule = require(`@/assets/theme/${config.theme}/${path}.tsx`) as IconModule;
    } catch {
        iconModule = require(`@/assets/theme/default/${path}.tsx`) as IconModule;
    }

    if (name in iconModule) {
        return iconModule[name];
    }

    throw new Error(`Icon ${name} not found`);
};

export const Icon = ({ path, ...props }: { path: string } & ComponentPropsWithoutRef<'svg'>) => {
    const ThemedIcon = getIcon(path);
    return <ThemedIcon data-testid="icon" {...props} />;
};
